import React, { useContext } from 'react';
import { FlaskConical } from 'lucide-react';
import { WindowSizeContext } from '/src/App';

import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import './style.css';

const Header = ({
    currentView,
    handleSectionMenuItemClick
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const puzzlePiecesIconPath = "get-quoll-what-if-plan-summary-puzzle-pieces-tan.png"

    let leftButtonSectionChangeToSection = 'changeProjects';
    let leftButtonSectionChangeToSectionText = 'Add / Remove Projects';
    let rightButtonSectionChangeToSection = 'generatePlan';
    let rightButtonSectionChangeToSectionText = 'Create My Action Plan';

    if ((currentView === 'changeProjects' || currentView === 'generate-a-plan')) {
        leftButtonSectionChangeToSection = 'analysis';
        leftButtonSectionChangeToSectionText = 'Return to Analysis';
    }

    return (
        <div className={`what-if-machine-plan-summary-header-container ${deviceType}`}>
            {(deviceType === 'mobile' && currentView !== 'summary') && (
                <div className={`what-if-machine-plan-summary-header-container-row`}>
                    <div className="what-if-machine-plan-summary-header-icon-container">
                        <FlaskConical />
                    </div>

                    <h2 className={`what-if-machine-plan-summary-header-title text-align-center ${deviceType}`}>Project Combo Lab</h2>
                </div>
            )}
            <div className={`what-if-machine-plan-summary-header-container-row`}>
                {currentView !== 'summary' && (
                    <div className="what-if-machine-plan-summary-header-button change" onClick={() => handleSectionMenuItemClick(leftButtonSectionChangeToSection)}>
                        {leftButtonSectionChangeToSectionText}
                    </div>
                )}
                {(deviceType !== 'mobile' || currentView === 'summary') && (
                    <div className="what-if-machine-plan-summary-header-title-container">
                        <div className="what-if-machine-plan-summary-header-icon-container">
                            <FlaskConical />
                        </div>

                        <h2 className={`what-if-machine-plan-summary-header-title text-align-center ${deviceType}`}>Project Combo Lab</h2>
                    </div>
                )}
                {currentView !== 'summary' && (
                    <div className="what-if-machine-plan-summary-header-button generate" onClick={() => handleSectionMenuItemClick('generate-a-plan')}>
                        {rightButtonSectionChangeToSectionText}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;